<div
  cdkDrag
  class="add_edit_common_main popup_main_div add_edit_task_matter_main"
  cdkDragRootElement=".cdk-overlay-pane"
>
  @if (isLoadingResults) {
    <div class="example-loading-shade">
      <mat-spinner [style.zoom]="1"></mat-spinner>
    </div>
  }
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>Add Tasks to Matter</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <div mat-dialog-content class="mat-typography main generate-docwrap" fxLayout="column">
    <form
      name="matterdetailForm"
      id="matterdetailForm"
      [formGroup]="matterdetailForm"
      class="w-full"
      fxLayout="row"
      fxLayoutAlign="start"
    >
      <mat-form-field class="example w-[40%]! pr-1" appearance="outline">
        <mat-label>Class</mat-label>
        <mat-select formControlName="MATTERCLASS" (ngModelChange)="Classtype($event)">
          @for (Classoption of Classdata; track Classoption) {
            <mat-option value="{{ Classoption.LOOKUPFULLVALUE }}">
              {{ Classoption.LOOKUPFULLVALUE }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
    <div fxLayout="row" fxLayoutAlign="start" class="letterhead-container">
      <div fxFlex="35" class="left-section">
        <h3>All Packs for {{ classtype }}</h3>
        <div class="example-containerdata resizable-table table-wrapper">
          @if (isDisp) {
            <div class="grid-overlay">
              <div class="grid-overlay-msg-disp">There is no data to display.</div>
            </div>
          }
          <table
            mat-table
            [dataSource]="TaskdataList"
            [@animateStagger]="{ value: '50' }"
            class="mattempletelist"
          >
            <ng-container matColumnDef="PACKDESCRIPTION">
              <th mat-header-cell *matHeaderCellDef>Description</th>
              <td
                mat-cell
                *matCellDef="let row"
                style="width: 100px !important; margin-right: 0 !important"
              >
                {{ row.PACKDESCRIPTION }}
              </td>
            </ng-container>
            <tr
              mat-header-row
              class="tbl_fix_header"
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              [style.background]="highlightedRowsList == row.TASKPACKGUID ? selectedColore : ''"
              [ngClass]="highlightedRowsList == row.TASKPACKGUID ? 'row-text-colore' : ''"
              highlightedRowsList="row.TASKPACKGUID"
              *matRowDef="let row; columns: displayedColumns"
              (click)="highlightedRowsList = row.TASKPACKGUID; clickRow(row)"
              [@animate]="{ value: '*', params: { y: '100%' } }"
            ></tr>
          </table>
        </div>
      </div>

      <div fxFlex="65" class="right-section">
        <h3>Tasks that will be created</h3>
        <div class="example-containerdata resizable-table table-wrapper">
          @if (isDisplay) {
            <div class="grid-overlay">
              <div class="grid-overlay-msg">There are no tasks to be added.</div>
            </div>
          }
          <table
            mat-table
            [dataSource]="Task_Pack_Item_dataSource"
            [@animateStagger]="{ value: '50' }"
            class="mattempletelist"
          >
            <ng-container matColumnDef="ROLEASSIGNEDTO">
              <th mat-header-cell *matHeaderCellDef>Assigned To</th>
              <td mat-cell *matCellDef="let row" style="margin-right: 0 !important">
                {{ row.ROLEASSIGNEDTO }}
              </td>
            </ng-container>
            <ng-container matColumnDef="DUEDATEDESCRIPTION">
              <th mat-header-cell *matHeaderCellDef>Due Date</th>
              <td mat-cell *matCellDef="let row" style="margin-right: 0 !important">
                {{ row.DUEDATEDESCRIPTION }}
              </td>
            </ng-container>
            <ng-container matColumnDef="TASKDESCRIPTION">
              <th mat-header-cell *matHeaderCellDef>Description</th>
              <td mat-cell *matCellDef="let row" style="margin-right: 0 !important">
                {{ row.TASKDESCRIPTION }}
              </td>
            </ng-container>
            <tr
              mat-header-row
              class="tbl_fix_header"
              *matHeaderRowDef="columnsToDisplay; sticky: true"
            ></tr>
            <tr
              mat-row
              [style.background]="highlightedRows == row.TASKPACKITEMGUID ? selectedColore : ''"
              [ngClass]="highlightedRows == row.TASKPACKITEMGUID ? 'row-text-colore' : ''"
              highlightedRows="row.TASKPACKITEMGUID"
              *matRowDef="let row; columns: columnsToDisplay"
              (click)="highlightedRows = row.TASKPACKITEMGUID; clickRowTP(row)"
              [@animate]="{ value: '*', params: { y: '100%' } }"
            ></tr>
          </table>
        </div>
      </div>
    </div>
  </div>

  <mat-dialog-actions class="popup_ftr justify-end!">
    <button matButton="filled" [disabled]="isDisplay" class="mat-accent" (click)="taskToMatter()">
      Add Tasks to Matter
    </button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Close</button>
  </mat-dialog-actions>
</div>
